var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane fade",attrs:{"id":"Bank_account","role":"tabpanel","aria-labelledby":"Bank_account-tab"}},[_c('div',{staticClass:"card pt-4"},[_c('v-server-table',{staticClass:"v-table row-pointer",attrs:{"columns":_vm.columns,"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }